<template>
  <div class="card shadow" id="errosGerais" ref="errosGerais">
    <div class="card-header">
      <h3 class="card-title" v-if="this.add">
        <img
          src="media/icons/duotune/general/gen055.svg"
          class="me-2"
        />Adicionar
      </h3>
      <h3 class="card-title" v-else>
        <img src="media/icons/duotune/general/gen055.svg" class="me-2" />Editar
      </h3>
      <div class="card-toolbar">
        <router-link
          to="/principal/ajuda/consultar"
          class="btn btn-sm btn-light"
        >
          <span class="svg-icon svg-icon-1">
            <inline-svg src="media/icons/duotune/arrows/arr079.svg" />
          </span>
          Voltar
        </router-link>
      </div>
    </div>
    <div class="card-body">
      <div
        v-if="loading"
        class="ms-7 mb-7"
        v-bind:data-kt-indicator="loading ? 'on' : 'off'"
      >
        <span class="indicator-progress">
          Aguarde, carregando...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
        <div
          v-if="this.errosGerais.Message"
          class="notice d-flex bg-light-danger rounded border-danger border border-dashed ms-0 me-0 mb-9 p-6"
        >
          <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
            <inline-svg src="media/icons/duotune/general/gen044.svg" />
          </span>
          <div class="d-flex flex-stack flex-grow-1">
            <div class="fw-bold">
              <h4 class="text-gray-800 fw-bolder">Aviso</h4>
              <div class="fs-6 text-gray-600">
                {{ this.errosGerais.Message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading">
        <div class="row">
          <div class="col-sm-12 col-md-5 col-lg-12 col-xl-5 col-xxl-5 mb-4">
            <div class="fv-row">
              <label class="form-label required">Descrição</label>
              <input
                id="txtDescricao"
                type="text"
                class="form-control mb-2"
                v-model="ajuda.descricao"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao[`descricao`] }}
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-7 col-lg-12 col-xl-7 col-xxl-7 mb-4">
            <div class="fv-row">
              <label class="form-label">Assunto</label>
              <input
                id="txtAssunto"
                type="text"
                class="form-control mb-2"
                v-model="ajuda.assunto"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao[`assunto`] }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-4"
          >
            <div class="fv-row">
              <div class="d-flex justify-content-between">
                <label class="form-label required">Categoria</label>
                <div class="card-toolbar">
                  <button
                    v-if="this.consultarAjudaCategoria"
                    type="button"
                    @click="this.modalAjudaCategorias(true)"
                    class="btn btn-sm btn-secondary px-2 py-0 m-0"
                  >
                    <span class="svg-icon svg-icon-1 m-0">
                      <inline-svg src="media/icons/duotune/general/gen041.svg"
                    /></span>
                  </button>
                </div>
              </div>
              <select
                class="form-select mb-0"
                data-placeholder="Selecione uma opção"
                v-model="ajuda.id_ajuda_categoria"
              >
                <template
                  v-for="categoria in this.categorias"
                  :key="categoria.id"
                >
                  <option :value="categoria.id">
                    {{ categoria.descricao }}
                  </option>
                </template>
              </select>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao[`id_ajuda_categoria`] }}
              </div>
            </div>
          </div>
          <div
            class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-4"
          >
            <div class="fv-row">
              <div class="d-flex justify-content-between">
                <label class="form-label required">Módulo</label>
                <div class="card-toolbar">
                  <button
                    v-if="this.consultarAjudaModuloCategoria"
                    type="button"
                    @click="consultarModulos(ajuda.id_ajuda_categoria)"
                    class="btn btn-sm btn-secondary px-2 py-0 m-0"
                  >
                    <span class="svg-icon svg-icon-1 m-0">
                      <inline-svg src="media/icons/duotune/general/gen041.svg"
                    /></span>
                  </button>
                </div>
              </div>
              <select
                class="form-select mb-0"
                data-placeholder="Selecione uma opção"
                v-model="ajuda.id_ajuda_modulo_categoria"
              >
                <template
                  v-for="modulo in this.carregarModulos(
                    ajuda.id_ajuda_categoria
                  )"
                  :key="modulo.id"
                >
                  <option :value="modulo.id">
                    {{ modulo.descricao }}
                  </option>
                </template>
              </select>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao[`id_ajuda_modulo_categoria`] }}
              </div>
            </div>
          </div>
          <div
            class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-4"
          >
            <div class="fv-row">
              <label class="form-label">Grupo de Usuários</label>
              <select
                class="form-select mb-0"
                data-placeholder="Selecione uma opção"
                v-model="ajuda.id_tipo_usuario"
              >
                <template
                  v-for="tipoUsuario in this.tiposUsuarios"
                  :key="tipoUsuario.id"
                >
                  <option :value="tipoUsuario.id">
                    {{ tipoUsuario.tipo }}
                  </option>
                </template>
              </select>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao[`id_tipo_usuario`] }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="d-flex flex-column col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 mb-4"
          >
            <div class="fv-row">
              <label class="form-label">Imagem Representativa</label>
              <div
                class="d-flex align-items-center justify-content-center card border border-rounded border-gray-300 mb-2 p-6 flex-grow-1"
              >
                <div class="d-flex flex-column align-items-center">
                  <div
                    id="imgImagem"
                    class="image-input image-input-outline"
                    data-kt-image-input="true"
                  >
                    <div
                      class="image-input-wrapper imagePreviewWrapper w-150px h-150px"
                      v-if="ajuda && ajuda.imagem"
                      :style="{ 'background-image': `url(${ajuda.imagem})` }"
                    ></div>
                    <div
                      class="image-input-wrapper imagePreviewWrapper w-150px h-150px"
                      v-else
                      :style="{
                        'background-image': `url(media/svg/files/blank-image.svg)`,
                      }"
                    ></div>
                    <label
                      class="btn btn-icon btn-circle btn-active-color-primary w-30px h-30px bg-white shadow"
                      data-kt-image-input-action="change"
                      data-bs-toggle="tooltip"
                      data-bs-dismiss="click"
                      title="Alterar imagem"
                    >
                      <i class="bi bi-pencil-fill fs-7"></i>
                      <input
                        ref="fileInput"
                        type="file"
                        name="avatar"
                        accept=".png, .jpg, .jpeg"
                        @input="pickFile"
                      />
                      <input type="hidden" name="avatar_remove" />
                    </label>
                    <span
                      class="btn btn-icon btn-circle btn-active-color-primary w-30px h-30px bg-white shadow"
                      data-kt-image-input-action="remove"
                      data-bs-toggle="tooltip"
                      @click="removerImagem()"
                      data-bs-dismiss="click"
                      title="Remover imagem"
                    >
                      <i class="bi bi-x fs-2"></i>
                    </span>
                  </div>
                  <div class="form-text text-center mt-6">
                    Selecione uma imagem. Apenas *.png, *.jpg e *.jpeg aquivo de
                    imagem é aceito
                  </div>
                  <div class="fv-plugins-message-container invalid-feedback">
                    {{ errosValidacao[`imagem`] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-8 col-xxl-8 mb-4">
            <div class="fv-row">
              <label class="form-label">Tags</label>
              <textarea
                id="txtTags"
                class="form-control mb-2"
                placeholder="Tags... Ex: #Cadastro #Financeiro #Movimentação"
                maxlength="255"
                style="height: 150px"
                v-model="ajuda.tags"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao[`tags`] }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mb-4">
            <div class="fv-row">
              <ckeditor
                :editor="editor"
                v-model="editorData"
                :config="editorConfig"
              ></ckeditor>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao[`conteudo`] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-4">
        <button
          class="btn btn-success svg-icon-white me-2 mb-2"
          @click="confirmarAjuda()"
          v-bind:data-kt-indicator="loading ? 'on' : 'off'"
        >
          <span class="indicator-progress">
            <span
              class="spinner-border spinner-border-sm align-middle ms-1"
            ></span>
            Aguarde...
          </span>
          <span class="svg-icon svg-icon-1" v-if="!loading">
            <inline-svg
              src="media/icons/duotune/arrows/arr016.svg"
              class="me-2"
            />Confirmar
          </span>
        </button>
        <router-link to="/principal/ajuda/consultar">
          <a class="btn btn-danger svg-icon-white mb-2">
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-4"
              />Cancelar
            </span>
          </a>
        </router-link>
      </div>
    </div>
  </div>
  <AjudaCategoriaModal
    v-if="exibirAjudaCategorias"
    :showSelection="false"
    @exibirModalAjudaCategorias="modalAjudaCategorias"
    @confirmarAjudaCategoria="carregarCategorias"
  ></AjudaCategoriaModal>
  <AjudaModuloCategoriaModal
    ref="ConsultaAjudaModuloCategorias"
    v-if="exibirAjudaModuloCategorias"
    :modal="true"
    :idAjudaCategoria="this.idAjudaCategoria"
    @exibirModalAjudaModuloCategorias="modalAjudaModuloCategorias"
    @confirmarAjudaModuloCategoria="carregarCategorias"
  ></AjudaModuloCategoriaModal>
</template>

<script>
import AjudaCategoriaModal from "@/views/ajuda/AjudaCategoriaModal.vue";
import AjudaModuloCategoriaModal from "@/views/ajuda/AjudaModuloCategoriaModal.vue";
import { ClassicEditor } from "@ckeditor/ckeditor5-editor-classic";

import { Alignment } from "@ckeditor/ckeditor5-alignment";
import { Autoformat } from "@ckeditor/ckeditor5-autoformat";
import {
  Bold,
  Italic,
  Strikethrough,
  Subscript,
  Superscript,
  Underline,
} from "@ckeditor/ckeditor5-basic-styles";
import { BlockQuote } from "@ckeditor/ckeditor5-block-quote";
import { CodeBlock } from "@ckeditor/ckeditor5-code-block";
import { Essentials } from "@ckeditor/ckeditor5-essentials";
import { FindAndReplace } from "@ckeditor/ckeditor5-find-and-replace";
import {
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
} from "@ckeditor/ckeditor5-font";
import { Heading, Title } from "@ckeditor/ckeditor5-heading";
import { Highlight } from "@ckeditor/ckeditor5-highlight";
import { HorizontalLine } from "@ckeditor/ckeditor5-horizontal-line";
import { HtmlEmbed } from "@ckeditor/ckeditor5-html-embed";
import {
  DataFilter,
  DataSchema,
  GeneralHtmlSupport,
  HtmlComment,
} from "@ckeditor/ckeditor5-html-support";
import {
  AutoImage,
  Image,
  ImageCaption,
  ImageInsert,
  ImageResize,
  ImageStyle,
  ImageToolbar,
  PictureEditing,
} from "@ckeditor/ckeditor5-image";
import { Indent, IndentBlock } from "@ckeditor/ckeditor5-indent";
import { AutoLink, Link, LinkImage } from "@ckeditor/ckeditor5-link";
import { List, ListProperties, TodoList } from "@ckeditor/ckeditor5-list";
import {
  MediaEmbed,
  MediaEmbedToolbar,
  AutoMediaEmbed,
} from "@ckeditor/ckeditor5-media-embed";
import { Mention } from "@ckeditor/ckeditor5-mention";
import { PageBreak } from "@ckeditor/ckeditor5-page-break";
import { Paragraph } from "@ckeditor/ckeditor5-paragraph";
import { PasteFromOffice } from "@ckeditor/ckeditor5-paste-from-office";
import { RemoveFormat } from "@ckeditor/ckeditor5-remove-format";
import { SelectAll } from "@ckeditor/ckeditor5-select-all";
import { ShowBlocks } from "@ckeditor/ckeditor5-show-blocks";
import { SourceEditing } from "@ckeditor/ckeditor5-source-editing";
import {
  SpecialCharacters,
  SpecialCharactersArrows,
  SpecialCharactersCurrency,
  SpecialCharactersEssentials,
  SpecialCharactersLatin,
  SpecialCharactersMathematical,
  SpecialCharactersText,
} from "@ckeditor/ckeditor5-special-characters";
import {
  Table,
  TableCaption,
  TableCellProperties,
  TableColumnResize,
  TableProperties,
  TableToolbar,
} from "@ckeditor/ckeditor5-table";
import { TextTransformation } from "@ckeditor/ckeditor5-typing";
import { Undo } from "@ckeditor/ckeditor5-undo";
import ImageRemoveEventCallbackPlugin from "ckeditor5-image-remove-event-callback-plugin";
import UploadAdapter from "@/utils/UploadAdapter";
import { useToast } from "vue-toastification";
const toast = useToast();
import { mapState } from "vuex";
import { hideModalId, getOrCreateInstanceModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

const ajudaInicializada = {
  id: 0,
  descricao: "",
  assunto: "",
  id_ajuda_categoria: 0,
  id_ajuda_modulo_categoria: 0,
  tags: "",
  imagem: "",
  conteudo: "",
  id_tipo_usuario: 0,
  formFile: null,
  imagemRemover: [],
};

function uploader(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    return new UploadAdapter(loader);
  };
}

export default {
  components: {
    AjudaCategoriaModal,
    AjudaModuloCategoriaModal,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    async showInvalidAlert(text) {
      await Swal.fire({
        text: text,
        icon: "warning",
        buttonsStyling: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn fw-bold btn-warning",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    handleEnterKey(event) {
      if (event.key === "Enter") {
        const confirmButton = document.querySelector(".swal2-confirm");
        if (confirmButton) {
          confirmButton.click();
        }
      } else if (event.key === "Escape") {
        const cancelButton = document.querySelector(".swal2-cancel");
        if (cancelButton) {
          cancelButton.click();
        }
      }
    },
    modalAjudaModuloCategorias(exibir) {
      this.exibirAjudaModuloCategorias = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_ajuda_modulo_categoria_consultar");
        }, 100);
      }
    },
    async consultarModulos(idAjudaCategoria) {
      this.idAjudaCategoria = idAjudaCategoria;
      if (this.idAjudaCategoria > 0) {
        this.modalAjudaModuloCategorias(true);
      } else {
        await this.showInvalidAlert(
          "É necessário selecionar uma categoria para consultar os módulos!"
        );
      }
    },
    carregarModulos(idAjudaCategoria) {
      const index = this.categorias.findIndex(
        (categoria) => categoria.id === idAjudaCategoria
      );
      if (index >= 0) {
        return this.categorias[index].AjudaModuloCategoria;
      } else {
        return [];
      }
    },
    modalAjudaCategorias(exibir) {
      this.exibirAjudaCategorias = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_ajuda_categorias_consultar");
        }, 100);
      }
    },
    removerImagems(images) {
      for (const element of images) {
        if (element != undefined && element != null && element != "") {
          this.imagensRemover.push(element);
        }
      }
    },
    async confirmarAjuda() {
      this.loading = true;
      this.errosGerais = {};
      this.errosValidacao = [];

      const blobsTemporarios = this.encontrarURLsBlob(this.editorData);
      const formFiles = await this.converterBlobsParaFormFiles(
        blobsTemporarios
      );

      if (formFiles.length > 0) {
        await this.uploadFormFiles(formFiles);
      }

      if (this.imagensRemover.length > 0) {
        for (var imagem of this.imagensRemover) {
          if (!this.editorData.includes(imagem)) {
            if (imagem.includes("blob")) {
              URL.revokeObjectURL(imagem);
            } else {
              if (this.ajuda.imagemRemover === undefined) {
                this.ajuda.imagemRemover = [];
              }
              this.ajuda.imagemRemover.push(
                imagem.replace(this.$utils.getUrl(), "")
              );
            }
          }
        }
      }

      this.ajuda.conteudo = this.editorData;
      this.ajuda.conteudo = this.ajuda.conteudo.replace(
        new RegExp(this.$utils.getUrl(), "g"),
        ""
      );

      this.ajuda.imagem =
        this.ajuda.imagem === null
          ? ""
          : this.ajuda.imagem.replace(this.$utils.getUrl(), "");

      console.log(this.ajuda);
      var formData = this.$utils.convertModelToFormData(this.ajuda);
      console.log(formData);
      if (this.ajuda.id === 0) {
        try {
          var ret = await this.$store.dispatch("ajuda/postAjuda", formData);
          if (ret.Success === true) {
            toast.success("Ajuda cadastrada com sucesso!", {
              timeout: 3000,
            });
            this.$router.push("/principal/ajuda/consultar");
          }
        } catch (error) {
          this.errosGerais = error;
          this.errosValidacao = error;
        }
      } else {
        try {
          var retPut = await this.$store.dispatch("ajuda/putAjuda", formData);
          if (retPut.Success === true) {
            toast.success("Ajuda atualizada com sucesso!", {
              timeout: 3000,
            });
            this.$router.push("/principal/ajuda/consultar");
          }
        } catch (error) {
          this.errosGerais = error;
          this.errosValidacao = error;
        }
      }

      if (this.ajuda.imagem !== "" && !this.ajuda.imagem.includes("base64")) {
        this.ajuda.imagem = this.$utils.getUrl() + this.ajuda.imagem;
      }

      this.loading = false;
    },
    async uploadFormFiles(formFiles) {
      const uploads = {
        ajudaUploadViewModel: formFiles.map((formFile) => ({
          imagem: "",
          formFile: formFile,
        })),
      };
      const formData = this.$utils.convertModelToFormData(uploads);
      try {
        var ret = await this.$store.dispatch("ajuda/postAjudaUpload", formData);
        if (ret.Success === true) {
          const urls = ret.Data;
          urls.forEach((url) => {
            const imagem = this.$utils.getUrl() + url.imagem;
            this.editorData = this.editorData.replace(
              new RegExp(url.formFile.FileName, "g"),
              imagem
            );
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    encontrarURLsBlob(html) {
      const blobRegex = /blob:[^'"]+/g;
      const matches = html.match(blobRegex);
      return matches ? matches : [];
    },
    async converterBlobsParaFormFiles(blobs) {
      const formFiles = [];

      for (const blobURL of blobs) {
        const blob = await this.blobURLParaBlob(blobURL);
        const formFile = this.blobParaFormFile(blob, blobURL);
        formFiles.push(formFile);
      }

      return formFiles;
    },
    blobURLParaBlob(blobURL) {
      return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", blobURL, true);
        xhr.responseType = "blob";
        xhr.onload = function () {
          resolve(xhr.response);
        };
        xhr.send();
      });
    },
    blobParaFormFile(blob, name) {
      const formFile = new File([blob], name, { type: "image/png" });
      return formFile;
    },
    async limparAjuda() {
      this.ajuda = JSON.parse(JSON.stringify(ajudaInicializada));

      this.errosGerais = {};
      this.errosValidacao = [];
      this.imagensRemover = [];
    },
    removerImagem() {
      if (this.add === true) {
        this.ajuda.imagemRemover.splice(0, this.ajuda.imagemRemover.length);
      } else {
        if (this.ajuda.imagemRemover === undefined) {
          this.ajuda.imagemRemover = [];
        }
        this.ajuda.imagemRemover.push(
          this.ajuda.imagem.replace(this.$utils.getUrl(), "")
        );
      }
      this.ajuda.imagem = "";
      this.ajuda.formFile = null;
      this.$refs.fileInput.value = null;
    },
    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          if (this.ajuda.imagem !== null) {
            if (this.ajuda.imagemRemover === undefined) {
              this.ajuda.imagemRemover = [];
            }
            this.ajuda.imagemRemover.push(
              this.ajuda.imagem.replace(this.$utils.getUrl(), "")
            );
          }

          this.ajuda.imagem = e.target.result;
          this.ajuda.formFile = file[0];
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }
    },
    async carregarTipoUsuario() {
      try {
        var ret = await this.$store.dispatch(
          "tipoUsuario/getTipoUsuarioOData",
          "?$select=id,tipo"
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.tiposUsuarios = ret.value;
        } else {
          this.errosGerais = {
            message: "Nenhum tipo de usuário foi encontrado!",
          };
        }
      } catch (error) {
        this.errosGerais = error;
      }
    },
    async carregarCategorias() {
      try {
        var ret = await this.$store.dispatch(
          "ajudaCategoria/getAjudaCategoriaOData",
          "?$expand=AjudaModuloCategoria"
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.categorias = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async carregarAjuda() {
      var id = this.$route.params.id;
      try {
        var ret = await this.$store.dispatch("ajuda/getAjuda", id);
        if (ret.Success === true) {
          this.ajuda = ret.Data;

          if (this.ajuda.imagem !== null && this.ajuda.imagem !== "") {
            this.ajuda.imagem = this.$utils.getUrl() + this.ajuda.imagem;
          }

          this.editorData = this.ajuda.conteudo;
          this.editorData = this.editorData.replace(
            new RegExp("/uploads/Ajuda", "g"),
            this.$utils.getUrl() + "/uploads/Ajuda"
          );
        }
      } catch (error) {
        this.errosGerais = error;
      }
      this.loading = false;
    },
    async asyncData() {
      if (this.$route.params.id !== undefined) {
        this.loading = true;
        this.add = false;
        await this.carregarAjuda();
      } else {
        this.add = true;
        this.limparAjuda();
      }
      this.carregarCategorias();
      this.carregarTipoUsuario();
    },
    async verificarRestricoes() {
      if (this.user.User.TipoUsuario.Restricao != null) {
        this.user.User.TipoUsuario.Restricao.find((element) => {
          if (element.regra === "Permitir.AjudaCategoria.Consultar") {
            this.consultarAjudaCategoria = true;
          }

          if (element.regra === "Permitir.AjudaModuloCategoria.Consultar") {
            this.consultarAjudaModuloCategoria = true;
          }
        });
      }
    },
  },
  watch: {
    $route: {
      handler: "asyncData",
      immediate: true,
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    this.asyncData();
  },
  data() {
    return {
      timeOut: null,
      idAjudaCategoria: 0,
      exibirAjudaCategorias: false,
      exibirAjudaModuloCategorias: false,
      categorias: [],
      tiposUsuarios: [],
      add: false,
      consultarAjudaCategoria: false,
      consultarAjudaModuloCategoria: false,
      loading: false,
      errosGerais: {},
      errosValidacao: [],
      imagensRemover: [],
      ajuda: JSON.parse(JSON.stringify(ajudaInicializada)),
      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        language: "pt-br",
        extraPlugins: [uploader],
        plugins: [
          Alignment,
          AutoImage,
          AutoMediaEmbed,
          AutoLink,
          Autoformat,
          BlockQuote,
          Bold,
          CodeBlock,
          DataFilter,
          DataSchema,
          Essentials,
          FindAndReplace,
          FontBackgroundColor,
          FontColor,
          FontFamily,
          FontSize,
          GeneralHtmlSupport,
          Heading,
          Highlight,
          HorizontalLine,
          HtmlComment,
          HtmlEmbed,
          Image,
          ImageCaption,
          ImageInsert,
          ImageResize,
          ImageStyle,
          ImageToolbar,
          Indent,
          IndentBlock,
          Italic,
          Link,
          LinkImage,
          List,
          ListProperties,
          MediaEmbed,
          MediaEmbedToolbar,
          Mention,
          PageBreak,
          Paragraph,
          PasteFromOffice,
          PictureEditing,
          RemoveFormat,
          SelectAll,
          ShowBlocks,
          SourceEditing,
          SpecialCharacters,
          SpecialCharactersArrows,
          SpecialCharactersCurrency,
          SpecialCharactersEssentials,
          SpecialCharactersLatin,
          SpecialCharactersMathematical,
          SpecialCharactersText,
          Strikethrough,
          Subscript,
          Superscript,
          Table,
          TableCaption,
          TableCellProperties,
          TableColumnResize,
          TableProperties,
          TableToolbar,
          TextTransformation,
          Title,
          TodoList,
          Underline,
          Undo,
          ImageRemoveEventCallbackPlugin,
        ],
        toolbar: {
          items: [
            "undo",
            "redo",
            "|",
            "heading",
            "|",
            "fontFamily",
            "fontSize",
            "fontColor",
            "fontBackgroundColor",
            "highlight",
            "removeFormat",
            "|",
            "bold",
            "italic",
            "underline",
            "strikethrough",
            "subscript",
            "superscript",
            "specialCharacters",
            "|",
            "alignment",
            "outdent",
            "indent",
            "|",
            "bulletedList",
            "numberedList",
            "todoList",
            "|",
            "link",
            "imageInsert",
            "mediaEmbed",
            "insertTable",
            "blockQuote",
            "codeBlock",
            "htmlEmbed",
            "|",
            "horizontalLine",
            "pageBreak",
            "|",
            "findAndReplace",
            "selectAll",
            "showBlocks",
            "sourceEditing",
          ],
        },
        image: {
          toolbar: [
            "imageTextAlternative",
            "toggleImageCaption",
            "imageStyle:inline",
            "imageStyle:block",
            "imageStyle:side",
            "linkImage",
          ],
        },
        table: {
          contentToolbar: [
            "tableColumn",
            "tableRow",
            "mergeTableCells",
            "tableCellProperties",
            "tableProperties",
          ],
        },
        imageRemoveEvent: {
          additionalElementTypes: null,
          callback: (imagesSrc, nodeObjects) => {
            this.removerImagems(imagesSrc);
          },
        },
        mediaEmbed: {
          previewsInData: true,
        },
        htmlSupport: {
          allow: [
            {
              name: /.*/,
              attributes: true,
              classes: true,
              styles: true,
            },
          ],
        },
      },
    };
  },
};
</script>

<style>
code {
  font-size: inherit !important;
  color: var(--kt-code-color) !important;
  text-shadow: none !important;
  font-family: var(--bs-font-monospace) !important;
}
.imagePreviewWrapper {
  background-size: contain !important;
  background-position: center !important;
}
</style>
